import axios from "@/lib/axios";

const getTerminateRequest = () => {
  return axios.get("/customer/flat_rates/terminate_request");
}

export default getTerminateRequest;